export const devicesLinks = {
  polarH10: 'https://amzn.to/3MLhAFD',
  coospoH808S: 'https://amzn.to/47iYZKA',
  polarVeritySense: 'https://amzn.to/3ZkVku4',
  appleWatch:
    'https://blog.pulsoid.net/post/pulsoid-supports-apple-watch-natively',
  wearOS:
    'https://blog.pulsoid.net/post/wearos-devices-are-now-natively-supported-by-pulsoid',
  fitbit: 'https://pulsoid.net/s/fitbit',
};
